import React, { useState } from 'react';
import { Button, ResponsiveImage } from '../../../../components';
import { useDispatch } from 'react-redux';
import { getSpaceMembersList } from '../../CircleCommunityPage.duck';
import SpaceMemberListModal from '../SpaceMemberListModal/SpaceMemberListModal';
import css from './SpaceMemberList.module.css';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import { abbreviateName } from '../../../../util/circleHelper';
import { getCommunityUserRole } from '../../../../util/data';
import { toast } from 'react-toastify';
const SpaceMemberList = props => {
  const { spaceMembersData, spaceDetail, onToggleSpaceMemberList, currentUserRole, userModeratorsGroups } = props;
  const { policies = {}, hide_members_count = false } = spaceDetail || {};

   const userRoleInGroup = getCommunityUserRole(userModeratorsGroups,spaceDetail?.id);

  if (hide_members_count) return null

  const isAdmin = ["admin","moderator"].includes(userRoleInGroup)


  const dispatch = useDispatch();
  const records = (spaceMembersData && spaceMembersData.records) || [];
  const visibleMembers = records.slice(0, 5);
  
  const handleShareGroup = () => {
    const groupUrl = typeof window !== 'undefined' ? window.location.href.replace('/my-group/', '/my-group-public/') : '';
    if (navigator.clipboard && groupUrl) {
      navigator.clipboard.writeText(groupUrl).then(() => {
        toast.success('Link copied to clipboard!', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });
      }).catch(err => {
        console.error('Failed to copy:', err);
        toast.error('Failed to copy link', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });
      });
    }
  };
  
  const handleSeeAllMembers = () => {
    const queryParams = {
      page: 1,
      per_page: 5,
      space_id: spaceDetail.id,
    };
    dispatch(getSpaceMembersList(queryParams, true, isAdmin));
    onToggleSpaceMemberList(true);
  };
  return (
    <div className={css.postWrapper}>
      <Button className={css.shareButton} onClick={handleShareGroup}>
        Share Group
      </Button>
      <div className={css.postHeading}> Members</div>
      <div>
        {visibleMembers.map((record, index) => (
          <div className={css.postItems} key={index}>
            <div className={css.postUserWrapper}>
              {record?.avatar_url ? (
                <ResponsiveImage
                  imagewithURL={record?.avatar_url}
                  alt={record?.avatar_url || 'space_member_avatar'}
                />
              ) : (
                <div className={css.nameWrapper}>{abbreviateName(record.name)}</div>
              )}
            </div>
            <div>
              <span className={css.postTitle}>{record.name}</span>
              <span className={css.postUser}>
                {['moderator'].includes(record?.userRoleInGroup) ? (
                  <ProfileIconCard type="moderator" />
                ) : null}
              </span>
            </div>
          </div>
        ))}
        {records.length > 5 && (
          <div className={css.seeMember} onClick={handleSeeAllMembers}>
            See members
          </div>
        )}
      </div>
    </div>
  );
};

export default SpaceMemberList;
